<template>
  <div>
    <button
      :id="_uid"
      :class="['btn btn-checkbox btn-light dropdown-toggle mr-2', buttonIcon]"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    ></button>
    <div class="stock dropdown-menu" :aria-labelledby="_uid">
      <div class="trims-imported-container" :class="selectedInTrim ? null : 'd-none'">
        <span :data-message="__('stock_equipment.import')" class="trims-imported" />
        <div role="separator" class="dropdown-divider"></div>
      </div>

      <label for="equipments[]" class="w-100 stock-equipment-checkbox assigned">
        <a href="#" @click.prevent="$emit('enable')">
          <span :class="['check-width', selected ? 'check' : '']"></span>
        </a>
        <a href="#" @click.prevent="$emit('enable')">
          {{ __('stock_equipment.display') }}
        </a>
      </label>

      <label
        :class="selectedInTrim ? null : 'd-none'"
        class="'w-100 stock-equipment-checkbox disable'"
        for="disableEquipment[]"
      >
        <a href="#" @click.prevent="$emit('disable')">
          <span :class="['check-width', selected ? '' : 'check']"></span>
        </a>
        <a href="#" @click.prevent="$emit('disable')">{{ __('stock_equipment.hide') }} </a>
      </label>
    </div>
  </div>
</template>

<script>
import { useId } from 'vue'
export default {
  name: 'EquipmentSelectionDropdown',
  props: {
    selectedInTrim: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['enable', 'disable'],
  computed: {
    _uid() {
      return useId()
    },
    buttonIcon() {
      return this.selected ? 'check' : 'cross'
    }
  }
}
</script>
